module.exports = __webpack_public_path__ + "img/menu-sign-up-icon.60385ede.svg";